import {
  Button,
  Menu,
  createStyles,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useState } from "react";
import swal from "sweetalert";
import FacilityModal from "../../containers/FacilityModal";
import { editFacility, removeFacility } from "../../services";
import { useNavigate } from "react-router-dom";
import { getAbbreviationFromName } from "../../utils";
import { BsThreeDotsVertical } from "react-icons/bs";

const useStyles = createStyles((theme) => ({
  bg1: {
    "& td": {
      background: "#fff",
    },
    cursor: "pointer",
  },
  bg2: {
    "& td": {
      background: "#F9FAFB",
    },
    cursor: "pointer",
  },
}));
const FacilityTableRow = ({ row, index }) => {
  const [active, setActive] = useState(row.active);
  const [opened, { open, close }] = useDisclosure(false);
  const [view, setView] = useState(false);
  const { classes } = useStyles();
  const navigate = useNavigate();

  const bg = index % 2 === 0;

  const selectedStateAbbr = getAbbreviationFromName(row?.state);

  // functions
  const remove = async (event) => {
    event.stopPropagation();
    const willDelete = await swal({
      title: `Are you sure?`,
      text: "This action cannot be undone. Facility are further associated to Client, Deleting facility can cause problems.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (willDelete) removeFacility(row);
  };
  const updateStatus = async (event) => {
    event.stopPropagation();
    setActive(event.target.checked);
    editFacility({ id: row?.id, active: event?.target?.checked }, false);
  };
  // function handleRowClick(id) {
  //   setView(id || true);
  //   open();
  // }

  const handleEditClick = (e) => {
    navigate(`/home/facility/${row.id}/edit`);
  };

  const handleRowClick = () => {
    navigate(`/home/facility/${row.id}/view`);
  };

  return (
    <tr
      style={{ cursor: "pointer" }}
      className={bg ? classes.bg2 : classes.bg1}
    >
      <td onClick={handleRowClick}>{row?.name || "-"}</td>
      <td onClick={handleRowClick}>{row.type?.name || "-"}</td>
      <td onClick={handleRowClick}>{row?.address || "-"}</td>
      <td onClick={handleRowClick}>{row?.zipcode || "-"}</td>
      <td onClick={handleRowClick}>{selectedStateAbbr || row?.state || "-"}</td>
      <td onClick={handleRowClick}>{row?.phone || "-"}</td>
      {/* <td className="exclude-modal-trigger">
        <Switch
          size="md"
          color="yellow"
          checked={active}
          onChange={updateStatus}
         
        />
      </td> */}
      <td className="exclude-modal-trigger">
        {/* <Group>
          <FacilityModal
            opened={opened}
            close={close}
            title={"Edit Facility"}
            data={row}
            view={view}
            setView={setView}
          />
          <ActionIcon
            color="yellow"
            variant="light"
            onClick={(event) => {
              event.stopPropagation();
              setView(true);
              open();
            }}
          >
            <IconEye />
          </ActionIcon>
          <ActionIcon
            color="green"
            variant="light"
            onClick={(event) => {
              event.stopPropagation();
              open(event);
            }}
          >
            <IconEdit />
          </ActionIcon>
          <ActionIcon color="red" variant="light" onClick={remove}>
            <IconTrash />
          </ActionIcon>
        </Group> */}
        <FacilityModal
          opened={opened}
          close={close}
          title={"Edit Facility"}
          data={row}
          view={view}
          setView={setView}
        />
        <div style={{ position: "relative", overflow: "visible" }}>
          <Menu shadow="md" width={100} withinPortal={true}>
            <Menu.Target>
              <Button variant="unstyled">
                <BsThreeDotsVertical />
              </Button>
              {/* <SlOptionsVertical size={16} /> */}
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item onClick={handleEditClick}>Edit</Menu.Item>
              <Menu.Item onClick={handleRowClick}>View</Menu.Item>
              <Menu.Item onClick={remove}>Delete</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      </td>
    </tr>
  );
};

export default FacilityTableRow;
